import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-responsive-modal';
import { VarHelper } from "common-import/helpers";

const units = [
  {
    label: "Area",
    options: [
      { label: "m2", value: "m2" },
      { label: "ft2", value: "ft2" },
      { label: "ft2", value: "ft2" },
      { label: "inch2", value: "inch2" },
      { label: "ha", value: "ha" }
    ]
  },
  {
    label: "Count",
    options: [
      { label: "sets", value: "sets" },
      { label: "dozen", value: "dozen" },
      { label: "in thousands", value: "in thousands" },
      { label: "pair", value: "pair" },
      { label: "pieces", value: "pieces" },
      { label: "packs", value: "packs" },
      { label: "roll", value: "roll" }
    ]
  },
  {
    label: "Length",
    options: [
      { label: "m", value: "m" },
      { label: "ft", value: "ft" },
      { label: "inch", value: "inch" },
      { label: "yd", value: "yd" },
      { label: "km", value: "km" },
      { label: "mm", value: "mm" },
      { label: "cm", value: "cm" },
      { label: "mile", value: "mile" }
    ]
  },
  {
    label: "Temprature",
    options: [
      { label: "K", value: "K" },
      { label: "F", value: "F" },
      { label: "C", value: "C" }
    ]
  },
  {
    label: "Volume",
    options: [
      { label: "Gal(US)", value: "Gal(US)" },
      { label: "Gal(UK)", value: "Gal(UK)" },
      { label: "l", value: "l" },
      { label: "cc", value: "cc" },
      { label: "ml", value: "ml" }
    ]
  },
  {
    label: "Mass",
    options: [
      { label: "ton", value: "ton" },
      { label: "lb", value: "lb" },
      { label: "kg", value: "kg" },
      { label: "g", value: "g" },
      { label: "oz", value: "oz" }
    ]
  },
  {
    label: "Time",
    options: [
      { label: "min", value: "min" },
      { label: "hour", value: "hour" },
      { label: "day", value: "day" },
      { label: "week", value: "week" },
      { label: "month", value: "month" },
      { label: "year", value: "year" }
    ]
  },
  {
    label: "Data",
    options: [
      { label: "bit", value: "bit" },
      { label: "byte", value: "byte" },
      { label: "kb", value: "kb" },
      { label: "mb", value: "mb" },
      { label: "gb", value: "gb" },
      { label: "tb", value: "tb" }
    ]
  }
];

export default class UnitsModal extends Component {
  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
    selected: PropTypes.object,
  };

  constructor(props) {
    super (props);

    this.state = {
      open: false,
    };

    this.onClose = this.onClose.bind(this);
  }

  onClose = () => {
    this.setState({ open: false });
    this.props.onClose();
  };

  handleSelect = (e, value) => {
    !!e && e.preventDefault();
    this.props.onSubmit({...this.props.selected, value});
  };

  componentDidUpdate(prevProps) {
    const { open } = this.props;
    if (open !== prevProps.open) this.setState({open});
  }

  render() {
    const classCustom = {
      "modal": "modal-custom units-modal",
      "closeButton": "close-button-custom",
    };

    const renderData = () => {
      return units.map((item, index) => {
        return <div className="block" key={item.label+index}>
          <h5># {item.label}</h5>
          <div className="unit-list">
            {item.options.map((itm, idx) => <span className={itm.value === this.props.selected.value ? "unit__item selected" : "unit__item"} key={itm.label+idx} onClick={e => this.handleSelect(e, itm.value)}>{itm.label}</span>)}
          </div>
        </div>
      })
    };

    return (
      <Modal classNames={classCustom} open={this.state.open} onClose={this.onClose}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Unit list</h5>
          </div>
          <div className="modal-body">
            <div className="preview">
              {renderData()}
            </div>
          </div>
          <div className="modal-footer">
            <button onClick={this.onClose} className="btn btn-sm btn-secondary">
              <i className="fa fa-ban"> </i> Close
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}




// WEBPACK FOOTER //
// ./src/custom/UnitsModal.js